import React, { useEffect, useState, useRef } from 'react';
interface AnimatedImageProps {
  src: string;
  alt: string;
  className?: string;
  onClick?: () => void;
}
export function AnimatedImage({
  src,
  alt,
  className = '',
  onClick
}: AnimatedImageProps) {
  const [isVisible, setIsVisible] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (imgRef.current) {
      observer.observe(imgRef.current);
    }
    return () => observer.disconnect();
  }, []);
  return <img ref={imgRef} src={src} alt={alt} onClick={onClick} className={`${className} transition-all duration-1000 ease-out ${isVisible ? 'scale-100 opacity-100' : 'scale-90 opacity-0'}`} data-id="element-1" />;
}